import type { TFunction } from 'i18next'

type RoomOccupancyLike = {
  male: number
  female: number
  childA: number
  childB: number
  childC: number
  childD: number
  childE: number
  childF: number
  childOther: number
}

export const formatRoomOccupancy = (roomOccupancy: RoomOccupancyLike, t: TFunction): string => {
  const adultParts: string[] = []
  if (roomOccupancy.male > 0) {
    adultParts.push(`${t('dashboard.MaleShort')}${roomOccupancy.male}`)
  }
  if (roomOccupancy.female > 0) {
    adultParts.push(`${t('dashboard.FemaleShort')}${roomOccupancy.female}`)
  }

  const childParts: string[] = []
  if (roomOccupancy.childA > 0) {
    childParts.push(`A${roomOccupancy.childA}`)
  }
  if (roomOccupancy.childB > 0) {
    childParts.push(`B${roomOccupancy.childB}`)
  }
  if (roomOccupancy.childC > 0) {
    childParts.push(`C${roomOccupancy.childC}`)
  }
  if (roomOccupancy.childD > 0) {
    childParts.push(`D${roomOccupancy.childD}`)
  }
  if (roomOccupancy.childE > 0) {
    childParts.push(`E${roomOccupancy.childE}`)
  }
  if (roomOccupancy.childF > 0) {
    childParts.push(`F${roomOccupancy.childF}`)
  }
  if (roomOccupancy.childOther > 0) {
    childParts.push(`${t('dashboard.ChildOtherShort')}${roomOccupancy.childOther}`)
  }

  const allParts = [...adultParts, ...childParts]
  return allParts.length > 0 ? allParts.join(' ') : '-'
}
